.field {
  display: flex;
  flex-direction: column;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
}

@keyframes errorAnimation {
  0%,
  100% {
    background-color: transparent;
  }
  50% {
    background-color: var(--primary-gradient2);
  }
}

.invalid {
  animation: errorAnimation 2s ease-in-out;
}
